import React from "react";
import {observer} from "mobx-react";
import {DropDownContainerBox} from "../boxes/drop-down-container.box";
import {ErrorMessageBox} from "../boxes/error-message.box";
import {DropDownLabelBox} from "../boxes/drop-down-label.box";
import {Check} from "@sparkware/app-utils";
import {Select} from "../../../../basic-ui-components/form/select.component";
import {NullableNumber} from "../../../../../common/types/nullable-types";
import {OrbitComponentWithState} from "../../../base-components/orbit-component-with-state/orbit-component-with-state";

export interface DropDownItem {
    value: NullableNumber;
    text: string;
}

export interface IDropDownSelectionResult {
    cancel: boolean;
    overrideValueOnCancel?: NullableNumber;
}

interface SpainGameLimitDropDownComponentProps {
    label: string;
    items: DropDownItem[];
    nullItemText?: string;
    onItemSelected: (value: NullableNumber) => Promise<IDropDownSelectionResult>;
    errorMessage?: string;
    className?: string;
}

interface SpainGameLimitDropDownComponentState {
    selectedOption: NullableNumber;
}

@observer
export class DropDownComponent extends OrbitComponentWithState<SpainGameLimitDropDownComponentProps, SpainGameLimitDropDownComponentState> {
    constructor(props: SpainGameLimitDropDownComponentProps) {
        super(props);
        this.state = {
            selectedOption: null
        };
    }

    private _onChange = async (eventData: any) => {
        let value: NullableNumber = null;
        if(eventData.target.value !== "0") {
            value = parseInt(eventData.target.value);
        }

        const selectionResult = await this.props.onItemSelected(value);
        if(selectionResult.cancel) {
            if(Check.isUndefined(selectionResult.overrideValueOnCancel)) {
                this.setState({
                    selectedOption: this.state.selectedOption
                });
            } else {
                this.setState({
                    selectedOption: selectionResult.overrideValueOnCancel
                });
            }

        } else {
            this.setState({
                selectedOption: value
            });
        }
    }

    private _renderErrorMessage = () => {
        return (
            <ErrorMessageBox visible={Boolean(this.props.errorMessage)}>
                {this.props.errorMessage}
            </ErrorMessageBox>
        );
    }

    render() {

        const items: DropDownItem[] = [...this.props.items];

        if(this.props.nullItemText) {
            items.splice(0, 0, {
                value: 0,
                text: this.props.nullItemText
            });
        }

        return (
            <DropDownContainerBox>
                <DropDownLabelBox>
                    {this.props.label}
                </DropDownLabelBox>
                <Select value={this.state.selectedOption ?? ""}
                        onChange={this._onChange}
                        hasError={Boolean(this.props.errorMessage)}
                        className={this.props.className}
                        width="100%">
                    {
                        items.map(item => <option value={item.value}
                                                  key={item.value}>
                            {item.text}
                        </option>)
                    }
                </Select>
                {this._renderErrorMessage()}
            </DropDownContainerBox>
        )
    }
}